<template>
    <div class="common-box border-t0 intendant CRM">
      <el-row class="row-one stair-title">
        <span class="row-one-title">输入客户姓名</span>
        <input class="in-box margin-l16" type="text">
        <button class="inquire-btn">查询</button>
      </el-row>
      <div class="width630">
        <el-table :data="messageData" class="table-single margin-t20">
          <el-table-column label="客户姓名" prop="adviserName"></el-table-column>
          <el-table-column label="客户号" prop="city"></el-table-column>
          <el-table-column label="所属理财顾问" prop="phone"></el-table-column>
          <el-table-column label="合作日期" prop="phone"></el-table-column>
          <el-table-column label="操作" >
            <template slot-scope="scope">
              <template>
                <div class="btn-box">
                  <span class="select"  @click="messageOpt(scope.row.id,'1')">解除关系</span>
                </div>
              </template>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-row class="row-one stair-title">
        <span class="row-one-title">输入顾问姓名</span>
        <input class="in-box margin-l16" type="text">
        <button class="inquire-btn">查询</button>
      </el-row>
      <div class="width630">

        <el-table :data="messageData" class="table-single margin-t20"
                  tooltip-effect="dark">
          <el-table-column
            type="selection"
            width="55">
          </el-table-column>
          <el-table-column label="客户姓名" prop="adviserName"></el-table-column>
          <el-table-column label="合作日期" prop="city"></el-table-column>
          <el-table-column label="所属理财顾问" prop="phone"></el-table-column>
          <el-table-column label="工号" prop="phone"></el-table-column>
        </el-table>
        <div class="btn-one">
          <button class="hitch">挂接关系至</button>
          <button class="roll">理财顾问名单 <i class="el-icon-arrow-down"></i></button>
        </div>
      </div>
    </div>
</template>

<script>
  import pdf from 'vue-pdf'
  export default {
    data(){
      return {
        messageData:[], //列表数据
        dialogTableVisible:false,//简历弹出框
        pdfUrl:'', //当前展示文件url
        pageTotalNum:'',
      }
    },
    mounted() {
      this.GetApplyList()
    },
    methods:{
      //操作
      messageOpt(num,data){
        console.log('操作信息',num,data)
        const vm = this
        vm.$http.post(vm.$apiPath.UpdataAdvisorCheck,{
          Managercode:vm.$commonJs.getCookie("code"),//管理员代码
          CheckType:data, //
          ID:num
        }).then(res=>{
          console.log('结果',res)
          if(res.data.code == 200){
            vm.$message.success('处理成功')
            vm.GetApplyList()
          }else{
            vm.$message.error(res.data.message)
          }
        })
      },
      //管理列表
      GetApplyList(){
        let vm = this
        vm.$http.post(vm.$apiPath.getApplyList,{}).then(res=>{
          console.log('查看数据',res)
          if(res.data.code == 200){
            vm.messageData = res.data.dataList
          }
        })
      },
    },
  }
</script>

<style scoped lang="less">
  .CRM{
    /deep/ .el-checkbox__input.is-checked .el-checkbox__inner, /deep/ .el-checkbox__input.is-indeterminate .el-checkbox__inner{
      background-color: @color0653A2;
      border-color: @color0653A2;
    }
    /deep/ .el-checkbox__inner{
      border-color: @color0653A2;
    }
    .btn-one{
      margin-top:10px;
      .hitch{
        width: 94px;
        height: 32px;
        background: @colorB2;
        border-radius: 5px;
        color:@wColor;
        font-size: 14px;
        font-weight: 500;
        border:1px solid @colorB2;
        margin-right: 13px;
      }
      .roll{
        width: 143px;
        height: 32px;
        border: 1px solid @colorC8;
        border-radius: 5px;
        font-size: 14px;
        font-weight: 400;
        color: @color3;
        line-height: 20px;
      }
    }
    .width630{
      width:630px;
    }
    .width670{
      width:670px;
    }
    .condition{
      color:@colorD24209;
    }
    .suspend{
      color:@color3;
    }
    .btn-box{
      display: flex;
      justify-content: space-between;
      align-items: center;
      .select{
        cursor: pointer;
        font-size: 14px;
        font-weight: 500;
        color: @color0653A2;
        display: inline-block;
        padding:0 17px;
      }
      .line{
        width: 1px;
        height: 13px;
        border-right: 1px solid #BFBFBF;
      }

    }

    .open-title{
      color: @color2B448F;
      font-weight: bold;
      cursor: pointer;
    }
    .btn{
      width: 44px;
      height: 22px;
      border: 1px solid @color2B448F;
      border-radius: 4px;
      font-size: 14px;
      font-weight: 500;
      color: @color2B448F;
      display: inline-block
    }
    .btn-bg{
      background: @color2B448F;
      color: @wColor;
    }
  }
</style>
